import { useRouter } from "next/router";
import constants from "../utils/constants";
function useCheckBulkActions() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (pathname.includes(constants.SCREENS.EXPANDED_WORKLIST)) {
    return true;
  }
  return false;
}
export default useCheckBulkActions;